module.exports = __webpack_public_path__ + "img/昆明医科大学第一附属医院.f61495d0.png";